import { globalStore } from '@thewhite/react-global-module/lib/store';
import { Provider } from 'mobx-react';
import isEqual from 'lodash.isequal';
import * as React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import mapStore from '../modules/Global/store/mapStore';
import saveStateMapStore from '../modules/Global/store/saveStateMapStore';
import activePageStore from '../modules/Global/store/activePageStore';
import NotFound from '../modules/Global/notFoundContainer';
import MainWrap from '../modules/Wrappers/mainWrap/mainWrapComponent';
import PreloaderBar from '../modules/Global/components/preloader-bar/preloader-bar';

interface IMainRouterProps {
    history?: History;
    location?: Location;
}

const stores = { globalStore, mapStore, activePageStore, saveStateMapStore };

export default class MainRouter extends React.Component<IMainRouterProps> {
    shouldComponentUpdate(nextProps: Readonly<{ history?: History; location?: Location }>): boolean {
        return !isEqual(this.props.location, nextProps.location);
    }

    render() {
        const MainPage = React.lazy(() => import('../modules/Main/pages/mainPage/mainPage'));
        const ArticlesList = React.lazy(() => import('../modules/Articles/pages/list/articlesListContainer'));
        const ArticleCard = React.lazy(() => import('../modules/Articles/pages/card/articleCardContainer'));

        return (
            <Provider
                {...stores}
            >
                <HashRouter>
                    <Switch>
                        <MainWrap
                            location={this.props.location}
                        >
                            <React.Suspense
                                fallback={
                                    <PreloaderBar/>
                                }
                            >
                                <Switch>
                                    <Route
                                        exact
                                        path={'/'}
                                        component={MainPage}
                                    />
                                    <Route
                                        exact
                                        path={'/wiki'}
                                        component={ArticlesList}
                                    />
                                    <Route
                                        exact
                                        path={'/article/:id'}
                                        component={ArticleCard}
                                    />
                                    <Route
                                        component={NotFound}
                                    />
                                </Switch>
                            </React.Suspense>
                        </MainWrap>
                        <Route
                            component={NotFound}
                        />
                    </Switch>
                </HashRouter>
            </Provider>
        );
    }
}
